import { render, staticRenderFns } from "./RegulatoryQuestions.vue?vue&type=template&id=6617e432&"
import script from "./RegulatoryQuestions.vue?vue&type=script&lang=js&"
export * from "./RegulatoryQuestions.vue?vue&type=script&lang=js&"
import style0 from "./RegulatoryQuestions.vue?vue&type=style&index=0&id=6617e432&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports